export default __webpack_public_path__ + "static/media/navbar-moderation-dark.4c63cde1.svg";